import { render, staticRenderFns } from "./DowngradeWarn.vue?vue&type=template&id=d0d4a718&lang=true"
import script from "./DowngradeWarn.vue?vue&type=script&lang=js"
export * from "./DowngradeWarn.vue?vue&type=script&lang=js"
import style0 from "./DowngradeWarn.vue?vue&type=style&index=0&id=d0d4a718&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports